
define('eteration/widgets/common/ui-force-password-renew',['jquery',
        'knockout',
        'eteration/eteration-ajax',
        'eteration/widgets/ui-i18n',
        'eteration/eteration-base',
        'eteration/ui/form-viewmodel',
        'eteration/eteration-i18n',
        'eteration/ui/validation-helper',
        'eteration/ui/signup-viewmodel',
        'eteration/widgets/ui-recaptcha',
        'eteration/widgets/ui-etrselect',
        'eteration/widgets/ui-dropdownselect',
        'eteration/widgets/ui-keyboard-events'],
    function($,ko,etrAjax,ui18,Eteration,FormViewModel,i18n,validation,Signup) {

        function ForcePasswordRenew(params) {
            var self = this;
            self.loginData =  ko.observable();
            $("#signinModal").modal("hide")

            function PasswordData(){
                var self = this;
                self.newPassword = ko.observable();
                self.confirmPassword = ko.observable();
                self.currentPassword = ko.observable();
            }

            self.passwordData = ko.observable(new PasswordData());
            self.wsMessageCode = ko.observable();
            ko.utils.extend(self, new FormViewModel.FormViewModel());
            setTimeout(function(){
                $('[data-bs-toggle="tooltip"]').tooltip({'customClass':'z-index-2005'});
            },700);


            self.validationContext = ko.jqValidation({
                customValidators: {
                    currentPasswordControl: function() {
                        if (self.passwordData().currentPassword().length == 0) {
                            return emptyFieldError();
                        }
                        if (self.passwordData().currentPassword().length < 4 || self.passwordData().currentPassword().length > 6) {
                            return passwordLenghtError();
                        }
                    },
                    newPasswordControl: function() {
                        if (self.passwordData().newPassword().length == 0) {
                            return emptyFieldError();
                        }
                        if (self.passwordData().newPassword().length !== 6) {
                            return emptyFieldError();
                        }
                        if(self.passwordData().currentPassword() == self.passwordData().newPassword()) {
                            return existingPasswordError();
                        }
                        if( /(.)\1\1/.test(self.passwordData().newPassword()) ){
                            return repeatedCharacterError();
                        }
                    },
                    confirmPasswordControl: function() {
                        if (self.passwordData().confirmPassword().length == 0) {
                            return emptyFieldError();
                        }
                        if (self.passwordData().confirmPassword().length !== 6) {
                            return emptyFieldError();
                        }
                        if( /(.)\1\1/.test(self.passwordData().newPassword()) ) {
                            return repeatedCharacterError();
                        }
                        if(self.passwordData().confirmPassword()!=self.passwordData().newPassword()){
                            return passwordMismatchError();
                        }
                    },
                },
                postValidators:[
                    {
                        name:"confirmPassword",
                        id:"confirmPassword",
                        func:function() {
                            if(self.passwordData().confirmPassword()!=self.passwordData().newPassword())
                                return passwordMismatchError();
                        }
                    },
                    {
                        name:"currentPassword",
                        id:"currentPassword",
                        func:function() {
                            if(self.passwordData().currentPassword().length < 4 || self.passwordData().currentPassword().length > 6)
                                return passwordLenghtError();
                        }
                    },
                    {
                        name:"newPassword",
                        id:"newPassword",
                        func:function() {
                            if(self.passwordData().newPassword().length !== 6)
                                return emptyFieldError();
                        }

                    }
                ]
            });


            function emptyFieldError() {
                return i18n.get("ERR-MS-MILES-96");
            }

            function repeatedCharacterError() {
                return i18n.get("ERR-MS-MILES-6573");
            }

            function passwordMismatchError() {
                return i18n.get("ERR-MS-LOGIN-25");
            }

            function passwordLenghtError() {
                return i18n.get("TextField-MS-LOGIN-1000");
            }

            function existingPasswordError(){
                return i18n.get("milesAndSmiles.password.existingpassword.warning");
            }


            function getPassword(inputId) {
                switch (inputId) {
                    case "newPassword":
                        return self.passwordData().newPassword();
                    case "confirmPassword":
                        return self.passwordData().confirmPassword();
                    case "currentPassword":
                        return self.passwordData().currentPassword();
                    default:
                        return '';
                }
            }
            function isAlphabetic(char) {
                return /^[a-zA-Z]$/.test(char);
            }
            function handleKeydown(event, $input) {
                validation.removeError($input);
                if (isAlphabetic(event.key)) {
                    event.preventDefault();
                    validation.showError($input, i18n.get("milesAndSmiles.password.warning"));
                } else {
                    validation.removeError($input);
                }
            }

            function handleFocusOut($input) {
                    removeError($input);
            }

            function removeError($input){
                validation.removeError($input)
            }

            $(document).on("keydown focusout", "#newPassword", function(event) {
                var $input = this;
                if (event.type === "keydown") {
                    handleKeydown(event, $input);
                } else if (event.type === "focusout") {
                    handleFocusOut($input);
                }
            });

            self.forceUpdatePassword=function(){
                var validationResult = self.validationContext.Validate();
                if(validationResult.valid){
                    params['password'] = self.passwordData().newPassword();
                    var data = {
                        oldPassword: self.passwordData().currentPassword(),
                        password: self.passwordData().newPassword(),
                        repassword: self.passwordData().confirmPassword(),
                    }
                    etrAjax.post({
                        app: 'app.ms',
                        service:'/miles/updatepassword',
                        disableErrorHandling : true,
                        data :data,
                        callback:function(response) {
                            if(response.type == "ERROR"){
                                self.wsMessageCode(response.error.validationMessages[0].msg);
                                $('#updatePasswordMessage').appendTo('body').modal("show");
                            }
                            else if(response.type == "SUCCESS" && response.data == "MS00201300"){
                                self.reLogin(params);
                            }
                        },
                        uiMap:uiMap

                    });
                }
            };
            self.reLogin = function(params) {
                etrAjax.post({
                    app: 'app.ms',
                    service: '/login/signin',
                    disableLoaderTimeout: true,
                    data: params,
                    setTokenX: true,
                    callback : function(response) {
                        if(response.type === "SUCCESS"){
                            window.location.reload();
                        }else {
                            if ("error" in response) {
                                var messages = response.error.validationMessages;
                                if(messages && messages.length){
                                    var msg;
                                    var code;
                                    for (var i = 0; i < messages.length; i++) {
                                        msg = messages[i].msg;
                                        code = messages[i].code;
                                        if (code == "MS00201205" || code == "MS00201210" || code == "MS00201211" || code == "MS00201212") {
                                            $('#error-messageHeader').html('<small><i class="fa fa-warning red"></i><span>' + i18n.get(msg) + '</span>&nbsp<span id="clickHereBtn" class="text-decoration-underline cursor-pointer">' + i18n.get("Error-MS-MS000FP") + '</span></small>');
                                            $("#clickHereBtn").click(function (e) {
                                                self.forgotPasswordMode(false);
                                                if(!$('#ob-passwordActivateLightbox').is(':visible')){
                                                    $("#ob-passwordActivateLightbox").appendTo('body').modal("show");
                                                }
                                                $("#signinModal").appendTo('body').modal("hide");
                                                e.preventDefault();
                                                e.stopPropagation();
                                            });
                                        } else {
                                            $('#error-messageHeader').html('<small><i class="fa fa-warning red"></i>' + i18n.get(msg) + '</small>');
                                        }
                                    }

                                    code = messages[0].code;
                                    msg = messages[0].msg;


                                    // there is no security question for this user.
                                    // so only will show information light box
                                    if (code === "MS00201221" || msg === "Error-MS-MS00201221") {
                                        self.webServiceMessageCode(code);
                                        self.showForgotPasswordInfoModal();
                                    }

                                    // 3 times wrong login attempt
                                    if(code === "MS00201225" || msg === "Error-MS-MS00201225") {
                                        self.webServiceMessageCode(code);
                                        self.showSecurityQuestionModal();
                                    }

                                    // pending member
                                    if (code === "MS00201205" || msg === "Error-MS-MS00201205") {
                                        self.webServiceMessageCode(code);
                                    }

                                    if(code === "MS00201212" || msg === "Error-MS-MS00201212" || code === "MS00201211" || msg === "Error-MS-MS00201211"){
                                        self.webServiceMessageCode("Error-MS-MS00201205");
                                    }
                                }


                                self.defillInputByGivenId('#password');
                            }
                        }
                    }
                });
            }

            var  passwordLengthFromAdminQuery ={
                app: 'app.ms',
                service:'/miles/passwordlengthfromadmin',
                callback:function(response) {
                    $("input[type=password]").attr("maxlength", response.data);
                }

            };
            etrAjax.get(passwordLengthFromAdminQuery);

            var uiMap = {
                'passwordData.oldPassword' : 'oldpassword',
                'passwordData.password' : 'newpassword',
                'passwordData.repassword' : 'repassword'
            };



            self.closeUpdatePasswordModal = function () {
                $('#updatePasswordMessage').modal("hide");
            };

            self.closeChangePasswordModal = function () {
                $('#changePasswordModal').modal("hide");
            };


        }
        return { ViewModel:  ForcePasswordRenew };

    });
